import { render, staticRenderFns } from "./modifyInfo.vue?vue&type=template&id=3b4ebf5e"
import script from "./modifyInfo.vue?vue&type=script&lang=js"
export * from "./modifyInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports